import _keysInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/keys";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/reduce";
import * as _ from "../../../util/lodash";
import React from 'react';
import { createComponent, PropTypes } from "../../../wayin-react";
import { wrapDisplayName, compose } from 'react-recompose';
import capitalize from "../../../util/capitalize";
/*
  {
    click: ['name']
  }
 */

var withHandlers = function withHandlers(handlers) {
  return function (Component) {
    var handlerNames = _keysInstanceProperty(_).call(_, handlers);

    return createComponent({
      displayName: wrapDisplayName(Component, 'withHandlers'),
      propTypes: {
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
      },
      defaultProps: {
        id: undefined
      },
      handlers: buildHandler(handlers, Component),
      render: function render(props) {
        return /*#__PURE__*/React.createElement(Component, updateProps(handlerNames, props));
      }
    });
  };
}; // click => handleClick


function handlify(handlerName) {
  return "handle" + capitalize(handlerName);
} // click => onClick


function onify(handlerName) {
  return "on" + capitalize(handlerName);
} // Maps handleClick to onClick and deletes handleClick


function updateProps(handlerNames, props) {
  var _props = _.clone(props);

  _forEachInstanceProperty(_).call(_, handlerNames, function (name) {
    if (!_.isNil(_props[onify(name)])) {
      _props[onify(name)] = _props[handlify(name)];
    }

    delete _props[handlify(name)];
  });

  return _props;
}
/*
 { click: ['name'] }

  =>

 {
  handleClick: p => (e, data) => {
    p.onClick(e, { value, id, name }
  }
 }
 */


function buildHandler(handlers) {
  var _handlers = _.mapValues(handlers, function (dataKeys, eventName) {
    dataKeys.push('id', 'value');
    return function (p) {
      return function (e, data) {
        if (data === void 0) {
          data = {};
        }

        var _data = _reduceInstanceProperty(_).call(_, dataKeys, function (acc, key) {
          if (_.has(data, key)) {
            acc[key] = data[key];
          } else if (_.has(p, key)) {
            acc[key] = p[key];
          }

          return acc;
        }, {});

        if (p.isDisabled !== true) {
          p[onify(eventName)](e, _data);
        }
      };
    };
  });

  return _.mapKeys(_handlers, function (handlerFuncs, eventName) {
    return handlify(eventName);
  });
}

export default withHandlers;
//# sourceMappingURL=map-handlers.js.map